// Данные для вставки продолжения принта на другую деталь: геометрия источника (base),
// но центр = глобальные координаты исходной части (units) и общий link_id. Деталь-приёмник
// клипует свою часть → принт визуально продолжается через шов. Вход не мутируется.
export function continuationLayerData(base, centerX, centerY, linkId) {
  return { ...base, center_x: centerX, center_y: centerY, link_id: linkId }
}
